export enum ReportingResultSetStatus {
  PENDING = 'pending',
  IMPORTING = 'importing',
  READY = 'ready',
  FAILED = 'failed',
}
